import {UserAdminComponent} from "./user-admin.component";

export default UserAdminComponent
